.image {
    width: 100%;
}
